export default __webpack_public_path__ + "static/media/page404.45ffe6e6.png";